// extracted by mini-css-extract-plugin
export var divider = "_1r-0";
export var dividerText = "_1r-2";
export var dividerVertical = "_1r-1";